import getTypeName from './getTypeName';

export default function isArray<T>(val: T): val is T & any[] {
  const typeName = getTypeName(val)?.toLowerCase();
  return (val as any)?.length !== undefined
    && (
      Array.isArray(val) === true
      || typeName === 'int8array'
      || typeName === 'uint8array'
      || typeName === 'uint8clampedarray'
      || typeName === 'int16array'
      || typeName === 'uint16array'
      || typeName === 'int32array'
      || typeName === 'uint32array'
      || typeName === 'float32array'
      || typeName === 'float64array'
      || typeName === 'bigint64array'
      || typeName === 'biguint64array'
    );
}
